import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PrimengModule } from '../../app/shared/primeng/primeng.module';

import {
  AppBreadcrumbComponent, AppFooterComponent, AppMainComponent, ContentHeaderComponent
  , AppMenuComponent, AppRightPanelComponent, AppTopBarComponent, AppMenuitemComponent,
  TableComponent,
  UserConfigModalComponent,
  FilterPanelUnMappedComponent
} from './component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  AppBreadcrumbService, MenuService, AuthService
} from './service';
import { MessageService } from 'primeng/api';
import { ApiErrorInterceptor, ApiRequestInterceptor, ApiResponseInterceptor, ApiEmptyResponseInterceptor } from './../core/interceptor';
import { SafePipe } from './pipe/safepipe';
import { DateTimeFilterComponent } from './component/date-time-filter/date-time-filter.component';
import { AvatarModule } from 'ngx-avatars';
import { CommonDialogComponent } from './component/common-dialog/common-dialog.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { KpiIndicatorsComponent } from './component/kpi-indicators/kpi-indicators.component';
import { ToastComponent } from './component/toast/toast.component';
import { FilterPanelComponent } from './component/filter-panel/filter-panel.component';
import { ContainerTypeInfoComponent } from './component/container-type-info/container-type-info.component';
import { CommonPanelComponent } from './component/common-panel/common-panel/common-panel.component';
import { FormatValuePipe } from './pipe/format-value.pipe';
import { NumberOnlyDirective } from './utility/restrict-decimal.directive';
import { FormatNumberWithSymbolPipe } from './pipe/format-number-with-symbol.pipe';
import { PortInfoComponent } from './component/port-info/port-info.component';
import { CountryInfoComponent } from './component/country-info/country-info.component';
import { CompanyInfoComponent } from './component/company-info/company-info.component';
import { CarrierInfoComponent } from './component/carrier-info/carrier-info.component';
import { FilterPanelTerminatedComponent } from './component/filter-panel-terminated/filter-panel-terminated.component';

@NgModule({
  declarations: [
    AppBreadcrumbComponent, AppFooterComponent, AppMainComponent, ContentHeaderComponent, NumberOnlyDirective,UserConfigModalComponent,
    , AppMenuComponent, AppRightPanelComponent, AppTopBarComponent, AppMenuitemComponent, FormatValuePipe, FormatNumberWithSymbolPipe,
    SafePipe, DateTimeFilterComponent, CommonDialogComponent, TableComponent, KpiIndicatorsComponent, ToastComponent, FilterPanelComponent,
    ContainerTypeInfoComponent, CommonPanelComponent, FormatValuePipe, FormatNumberWithSymbolPipe, PortInfoComponent, CountryInfoComponent,
    CompanyInfoComponent, CarrierInfoComponent, FilterPanelUnMappedComponent, FilterPanelTerminatedComponent
  ],
  imports: [
    PrimengModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    AvatarModule,
    NgxDaterangepickerMd.forRoot()
  ],
  providers: [
    MessageService,
    AppBreadcrumbService, MenuService, AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiRequestInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiResponseInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiEmptyResponseInterceptor,
      multi: true
    }
  ],
  exports: [PrimengModule, ContentHeaderComponent, FilterPanelComponent,
    CommonDialogComponent, TableComponent, FormatValuePipe, NumberOnlyDirective, FormatNumberWithSymbolPipe,UserConfigModalComponent,
    AppFooterComponent, AppTopBarComponent, KpiIndicatorsComponent, ToastComponent, ContainerTypeInfoComponent, PortInfoComponent, 
    CountryInfoComponent, CompanyInfoComponent, CarrierInfoComponent, FilterPanelUnMappedComponent, FilterPanelTerminatedComponent]
})
export class AppCommonModule { }
